
import { startConversationUserInfo } from './startConversationUserInfo'
import { StartConversationContext } from './types'

export const initiateChat = (ctx: StartConversationContext) => {
  startConversationUserInfo(ctx)
}
